import { createSlice } from '@reduxjs/toolkit';
import { signOut } from '../thunks/authentication';

export const INITIAL_STATE = {
  loading: true,
  pageTitle: '',
  pageSubtitle: '',
  monitoring: {
    isMapOpen: false,
  },
  settings: {
    isSidebarOpen: false,
  },
  isLoggedAsCustomer: false,
};

export const rootSlice = createSlice({
  name: 'root',
  initialState: INITIAL_STATE,
  reducers: {
    toggleMonitoringMapStatus: (state) => {
      state.monitoring.isMapOpen = !state.monitoring.isMapOpen;
    },
    toggleSettingsSidebarStatus: (state) => {
      state.settings.isSidebarOpen = !state.settings.isSidebarOpen;
    },
    closeSettingsSidebarStatus: (state) => {
      state.settings.isSidebarOpen = false;
    },
    openSettingsSidebarStatus: (state) => {
      state.settings.isSidebarOpen = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
    },
    setPageSubtitle: (state, action) => {
      state.pageSubtitle = action.payload;
    },
    toggleCustomerMode: (state) => {
      state.isLoggedAsCustomer = !state.isLoggedAsCustomer;
    },
    setCustomerMode: (state) => {
      state.isLoggedAsCustomer = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signOut.fulfilled, (state) => {
      state.isLoggedAsCustomer = false;
    });
  },
});

export const {
  removeUser,
  setPageTitle,
  setPageSubtitle,
  stopLoading,
  toggleMonitoringMapStatus,
  toggleSettingsSidebarStatus,
  closeSettingsSidebarStatus,
  openSettingsSidebarStatus,
  toggleCustomerMode,
  setCustomerMode,
} = rootSlice.actions;

export default rootSlice.reducer;
